import React from 'react';
import { fx } from '../../fx.js';
import { ink } from '../../primitives.js';

const h = React.createElement;

/**
 * On/off switch: lime track when on; the knob travels on ease-pop.
 *
 * @param {object} p
 * @param {boolean} [p.on]
 * @param {React.MouseEventHandler} [p.onClick]
 * @param {'sm'|'md'} [p.size]
 * @param {string} [p.title]
 */
export function Toggle({ on, onClick, size = 'md', title }) {
  const sm = size === 'sm', W = sm ? 28 : 36, H = sm ? 16 : 20, K = H - 6;
  const knob = React.useRef(null), first = React.useRef(true);
  React.useEffect(() => { if (first.current) { first.current = false; return; } const f = fx; if (f.reduced && !f.reduced()) f.animate(knob.current, [{ scale: '1 1' }, { scale: '1.5 .7' }, { scale: '.9 1.1' }, { scale: '1 1' }], { duration: 300, easing: 'ease-out' }); }, [on]);
  return h('button', {
    type: 'button', role: 'switch', 'aria-checked': !!on, onClick, title,
    style: { position: 'relative', width: W, height: H, padding: 0, border: ink(1.5), borderRadius: 20, background: on ? 'var(--lime)' : 'var(--track)', cursor: 'pointer', transition: 'background-color var(--dur-fast) var(--ease-out)', boxSizing: 'border-box' }
  }, h('span', {
    ref: knob, style: { position: 'absolute', top: 2, left: 2, width: K, height: K, borderRadius: '50%', background: on ? 'var(--on-accent)' : 'var(--ink)', transform: on ? `translateX(${W - K - 7}px)` : 'translateX(0)', transition: 'transform var(--dur-base) var(--ease-pop)' }
  }));
}
